import './components/diseñocss/App.css';
import { Routes, Route, Navigate } from "react-router-dom"
import React, { useState, createContext, useContext } from 'react';
import Seleccion from './components/paginas_platos/Seleccion';
import SoloVerMenus from './components/paginas_platos/SoloVerMenus';
import CargaDiaria from './components/paginas_platos/CargaDiaria';
import CargaMenuSemanal from './components/paginas_platos/CargaMenuSemanal';
import AbmPlatos from './components/paginas_platos/AbmPlatos';
import AbmPedidos from './components/paginas_platos/AbmPedidos';
import AbmTiposPlato from './components/paginas_platos/AbmTiposPlato';
import AbmBebidas from './components/paginas_platos/AbmBebidas';
import CrearPlatos from './components/paginas_platos/CrearPlatos';
import CrearTipoPlato from './components/paginas_platos/CrearTipoPlato';
import EditarPlatos from './components/paginas_platos/EditarPlatos';
import EditarTipoPlato from './components/paginas_platos/EditarTipoPlato';
import CreateUser from './components/paginas_usuarios/CreateUser';
import EditUser from './components/paginas_usuarios/EditUser';
import AbmUsuarios from './components/paginas_usuarios/AbmUsuarios';
import Login from './components/paginas_usuarios/Login';
import ConfigPage from './components/paginas_usuarios/ConfigPage';


//Importacion de barras de usuarios según el tipo de usuario
import NavBarAdmin from './components/barradeNavegacion/NavBarAdmin.jsx';
import NavBarUser from './components/barradeNavegacion/NavBarUser.jsx';
import Footer from './components/footer/Footer.jsx'
import '../src/components/diseñocss/App.css'

//Importacion de tocken para la autenticacion del usuario
import { AuthProvider, useAuth } from './components/guardarToken/authContext';
import AbmEmpresas from './components/paginas_usuarios/AbmEmpresas.jsx';
import CreateEmpresa from './components/paginas_usuarios/CreateEmpresa.jsx';
import EditEmpresa from './components/paginas_usuarios/EditEmpresa.jsx';
import AbmDirecciones from './components/paginas_usuarios/AbmDirecciones.jsx';
import CreateAddres from './components/paginas_usuarios/CreateDirecciones.jsx';
import EditAddres from './components/paginas_usuarios/EditAddres.jsx';
import AbmSectores from './components/paginas_usuarios/AbmSectores.jsx';
import CreateSection from './components/paginas_usuarios/CreateSector.jsx';
import EditSection from './components/paginas_usuarios/EditSector.jsx';
import Dashpage from './components/Dashboard/Dashpage.jsx';
import VistaPedidoSemanal from './components/paginas_platos/VistaPedidoSemanal.jsx';

// Contexto para el estado del drawer
const DrawerContext = createContext();
export const useDrawer = () => useContext(DrawerContext);






function App() {


  return (



    <AuthProvider>

      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ver-menu" element={<SoloVerMenus isPublic={true} />} />
          <Route path="/ver-menu/:id_sede" element={<SoloVerMenus isPublic={true} />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <AdminRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user/*"
            element={
              <ProtectedRoute allowedRoles={['user', 'admin', 'superadmin']}>
                <UserRoutes />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>

    </AuthProvider>

  );
}
function Home() {
  const { authToken, tipoUsuario } = useAuth();

  // Si no hay token activo, forzar login
  const token = authToken || sessionStorage.getItem('token');
  if (!token) {
    return <Login />;
  }

  if (tipoUsuario === 'admin' || tipoUsuario === 'superadmin') {
    return <Navigate to="/admin/dashpage" />;
  } else {
    return <Navigate to="/user/mipedidosemanal" />;
  }
}

function ProtectedRoute({ children, allowedRoles }) {
  const { authToken, tipoUsuario } = useAuth();
  const token = authToken || sessionStorage.getItem('token');
  const role = tipoUsuario || localStorage.getItem('tipoUsuario');

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && role && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function AdminRoutes() {
  const [drawerExpanded, setDrawerExpanded] = useState(true);

  return (
    <DrawerContext.Provider value={{ drawerExpanded, setDrawerExpanded }}>
      <div>
        <NavBarAdmin />
        <div style={{
          marginLeft: drawerExpanded ? '280px' : '80px',
          transition: 'margin-left 0.3s',
          minHeight: '100vh'
        }}>
          <Routes>
            <Route path="dashpage" element={<Dashpage />} />
            <Route path="config" element={<ConfigPage />} />
            <Route path="mipedidosemanal" element={<VistaPedidoSemanal />} />
            <Route path="seleccion" element={<Seleccion />} />
            <Route path="vermenusolo" element={<SoloVerMenus />} />
            <Route path="cargadiaria" element={<CargaDiaria />} />
            <Route path="CargarMenuSemanal" element={<CargaMenuSemanal />} />
            <Route path="AbmUsuarios" element={<AbmUsuarios />} />
            <Route path="AbmEmpresas" element={<AbmEmpresas />} />
            <Route path="AbmDirecciones" element={<AbmDirecciones />} />
            <Route path="AbmSectores" element={<AbmSectores />} />
            <Route path="AbmPlatos" element={<AbmPlatos />} />
            <Route path="AbmPedidos" element={<AbmPedidos />} />
            <Route path="tipos-plato" element={<AbmTiposPlato />} />
            <Route path="bebidas" element={<AbmBebidas />} />
            <Route path="CreateAddres" element={<CreateAddres />} />
            <Route path="CreatePlatos" element={<CrearPlatos />} />
            <Route path="crear-tipo-plato" element={<CrearTipoPlato />} />
            <Route path="CreateUser" element={<CreateUser />} />
            <Route path="CreateEmpresa" element={<CreateEmpresa />} />
            <Route path="CreateSection" element={<CreateSection />} />
            <Route path="EditEmpresa/:id" element={<EditEmpresa />} />
            <Route path="EditAddres/:id_direccion" element={<EditAddres />} />
            <Route path="EditSection/:id_sector" element={<EditSection />} />
            <Route path="EditarPlatos/:id_plato" element={<EditarPlatos />} />
            <Route path="editar-tipo-plato/:id" element={<EditarTipoPlato />} />
            <Route path="EditUser/:id" element={<EditUser />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </DrawerContext.Provider>
  );
}

function UserRoutes() {
  return (
    <div>
      <NavBarUser />

      <Routes>
        <Route path="mipedidosemanal" element={<VistaPedidoSemanal />} />
        <Route path="seleccion" element={<Seleccion />} />
        <Route path="vermenusolo" element={<SoloVerMenus />} />
      </Routes>

      <Footer />
    </div>
  );
}



export default App;
